import axios from "axios";
const setUrl = "https://esim-api.websa.tech/api";
// const setUrl = "http://localhost:6003/api";

const axiosClient = axios.create({
  baseURL: setUrl,
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw error;
  }
);

export default axiosClient;
